import {
    apiRequest,
    HollydayDetail,
    HollydayUpdate,
    HollydayCheckdate
} from "../../../../../services/adapters/master/hollydayService"

class CreateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", HollydayDetail, {
            params: query
        }, true)
    }
    fetchUpdate = async (query) => {
        return await apiRequest("post", HollydayUpdate, {
            body: query
        }, true)
    }
    fetchCheck = async (query) => {
        return await apiRequest("post", HollydayCheckdate, {
            body: query
        }, true)
    }

}

export default CreateRepository